<template>
    <v-main>
        <v-container fluid>
            <v-row no-gutters>

                <v-col cols="9" sm="8" md="8" lg="8" class="pa-0">
                    <v-card flat outlined class="navpanel" :color="emailbody.backgroundcolor">
                        <v-btn fab class="badgeicon" v-if="toolbar!=='drafts'"
                               :style="`position:absolute;top:${toolboxtop}px;left:0;`"
                               :color="`${preview?'black':'primary'}`"
                               @click="toolbar=(toolbar==='edit')?'preview':'edit'">
                            <v-icon color="white" v-if="toolbar==='edit'">{{icons.search}}</v-icon>
                            <v-icon color="white" v-else>{{icons.edit}}</v-icon>
                        </v-btn>
                        <v-btn fab bottom
                               v-if="activeuuid"
                               :style="`position:absolute;bottom:10px;left:0;`"
                               color="primary"
                               @click="confirmSend()"
                        >
                            <v-icon color="white">{{icons.send}}</v-icon>
                        </v-btn>
                        <v-card-text class="py-0 px-0">
                            <!--EMAIL DISPLAY STARTS HERE-->
                            <div v-if="org"
                                 :style="`text-align: ${emailbody.bodyalignment};padding-top:${emailbody.bodypaddingy}px;padding-bottom:${ emailbody.bodypaddingy}px;`">
                                <EmailPreview v-if="toolbar==='preview'||preview" :blocks="blocks"
                                              :width="emailbody.bodywidth" :body="emailbody"/>
                                <drop v-else
                                      :style="`width:${emailbody.bodywidth}px;min-width:300px;max-width:800px;border-radius:${emailbody.borderradius}px;`"
                                      :class="`dropcontainer ${(dragover)?'dragover':''}`" @dragover="dragover=true;"
                                      @dragleave="dragover=false" @drop="handleDrop">
                                    <draggable
                                            v-model="blocks"
                                            animation="200"
                                            :sort="!editindex"
                                            ghost-class=".ghost"
                                            dragover-bubble
                                            @end="log($event)"
                                    >
                                        <!--allows auto closing the editstate, and let drag begin-->
                                        <div class="bodyblocks" v-for="(d,i) in blocks" :key="i">
                                            <div class="content"
                                                 :class="['flexbox', {activeblock:(editindex===i)}]"
                                                 @mouseenter="blockhover=i" @mouseleave="blockhover=undefined">
                                                <v-icon class="badgeicon">{{d.icon}}</v-icon>
                                                <v-btn large v-if="editindex!==i" icon
                                                       :class="['editbutton',{hidden:blockhover!==i}]"
                                                       @click="editBlock(i)" :disabled="status!='draft'">
                                                    <v-icon>{{icons.edit}}</v-icon>
                                                </v-btn>
                                                <v-btn large v-if="editindex===i" icon
                                                       :class="['editbutton',{hidden:blockhover!==i}]"
                                                       @click="closeEdit()" :disabled="status!='draft'">
                                                    <v-icon>{{icons.checkon}}</v-icon>
                                                </v-btn>
                                                <!--HEADER-->
                                                <Header v-if="d.type==='header'" :d="d" :active="(editindex===i)"
                                                        :bodypadding="emailbody.bodypadding"/>
                                                <!--EDIT BLOCKS TEXT-->
                                                <BText v-if="d.type==='text'" :d="d" :active="(editindex===i)"
                                                       :bodypadding="emailbody.bodypadding"/>
                                                <!--EDIT BLOCKS BOXED-TEXT-->
                                                <BoxedText v-if="d.type==='boxed text'" :d="d" :active="(editindex===i)"
                                                           :bodypadding="emailbody.bodypadding"/>
                                                <!--EDIT BLOCKS IMAGE-->
                                                <BImage v-if="d.type==='image'" :d="d" :active="(editindex===i)"
                                                        :bodypadding="emailbody.bodypadding"/>
                                                <!--BUTTON-->
                                                <BButton v-if="d.type==='button'" :d="d" :active="(editindex===i)"
                                                         :bodypadding="emailbody.bodypadding"/>
                                                <!--SPACER-->
                                                <Spacer v-if="d.type==='spacer'" :d="d" :active="(editindex===i)"
                                                        :bodypadding="emailbody.bodypadding"/>
                                                <!--SOCIAL-->
                                                <Social v-if="d.type==='social'" :d="d" :active="(editindex===i)"
                                                        :bodypadding="emailbody.bodypadding"/>
                                                <!--FOOTER-->
                                                <BFooter v-if="d.type==='footer'" :d="d" :active="(editindex===i)"
                                                         :bodypadding="emailbody.bodypadding"/>
                                                <!--END EDIT BLOCKS-->
                                            </div>
                                        </div>
                                    </draggable>
                                </drop>
                            </div>

                        </v-card-text>
                    </v-card>
                    <!--NOTE sportsEngine SuperList-->
                </v-col>

                <v-col cols="3" sm="4" md="4" lg="4" class="py-0 pr-0 pl-1">
                    <div v-if="toolbar==='preview'" class="text-center mt-9">
                        <!--SPACER-->
                        <div :style="`height:${toolboxtop}px;width:100%;`"></div>
                        <v-btn outlined style="width:200px;height:200px;" @click="toolbar='edit'">
                            <v-icon style="transform: scale(3)" v-if="toolbar==='edit'">{{icons.search}}</v-icon>
                            <v-icon style="transform: scale(3)" v-else>{{icons.edit}}</v-icon>
                        </v-btn>
                    </div>
                    <div v-if="toolbar==='edit'">
                        <!--SPACER for keeping menu in frame -->
                        <div :style="`height:${toolboxtop}px;width:100%;`"></div>

                        <!--TOOLPANELS-->
                        <v-card flat v-if="activeeditblock">
                            <v-card-text class="pa-1">

                                <!--BODY EDITING-->
                                <v-card outlined v-if="activeeditblock.type==='body'">
                                    <v-card-title class="text-capitalize">{{activeeditblock.type}}</v-card-title>
                                    <v-card-text class="pa-1" scrollable>
                                        <v-text-field
                                                v-model="emailsubject"
                                                outlined
                                                label="Email Subject"
                                                hint="Enter a subject for this email"
                                                dense
                                        ></v-text-field>
                                        <v-color-picker flat label="Margin Background Color" hide-inputs
                                                        canvas-height="100"
                                                        v-model="emailbody.backgroundcolor"></v-color-picker>
                                        <v-slider thumb-label label="Width" min="300" max="800"
                                                  v-model="emailbody.bodywidth"></v-slider>
                                        <v-slider thumb-label label="X-Padding" min="0" max="100"
                                                  v-model="emailbody.bodypadding"></v-slider>
                                        <v-slider thumb-label label="Y-Padding" min="0" max="100"
                                                  v-model="emailbody.bodypaddingy"></v-slider>
                                        <v-slider thumb-label label="Round Corners" min="0" max="100"
                                                  v-model="emailbody.borderradius"></v-slider>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-btn outlined small @click="setFontSize()">
                                            <v-icon>{{`mdi-numeric-${sizeindex}`}}</v-icon>
                                        </v-btn>
                                        <v-btn depressed dark small @click="setFontWeight()">
                                            <v-icon :style="`font-weight:${activeeditblock.fontweight}`">
                                                mdi-format-font
                                            </v-icon>
                                        </v-btn>
                                        <v-spacer></v-spacer>
                                        <v-btn icon :outlined="emailbody.bodyalignment==='left'"
                                               @click="emailbody.bodyalignment='left'">
                                            <v-icon>mdi-page-layout-header mdi-rotate-90</v-icon>
                                        </v-btn>
                                        <v-btn icon :outlined="emailbody.bodyalignment==='center'" small
                                               @click="emailbody.bodyalignment='center'">
                                            <v-icon>mdi-page-layout-header-footer mdi-rotate-90</v-icon>
                                        </v-btn>
                                        <v-btn icon small :outlined="emailbody.bodyalignment==='right'"
                                               @click="emailbody.bodyalignment='right'">
                                            <v-icon>mdi-page-layout-header mdi-rotate-270</v-icon>
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>

                                <!--HEADER EDITING-->
                                <v-card outlined v-if="activeeditblock.type==='header'">
                                    <v-card-title class="text-capitalize">{{activeeditblock.type}}</v-card-title>
                                    <v-card-text class="pa-1 text-center" scrollable>
                                        <v-color-picker width="300" flat canvas-height="100" hide-inputs
                                                        v-model="activeeditblock.backgroundcolor"></v-color-picker>
                                        <v-slider thumb-label label="Padding" min="0" max="100"
                                                  v-model="activeeditblock.padding"></v-slider>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-btn outlined small @click="setFontSize()">
                                            <v-icon>{{`mdi-numeric-${sizeindex}`}}</v-icon>
                                        </v-btn>
                                        <v-btn v-if="activeeditblock.type==='boxed text'" depressed
                                               :dark="activeeditblock.color==='black'" :color="activeeditblock.color"
                                               small @click="setTextColor()">
                                            <v-icon>mdi-ghost</v-icon>
                                        </v-btn>
                                        <v-btn depressed dark small @click="setFontWeight()">
                                            <v-icon :style="`font-weight:${activeeditblock.fontweight}`">
                                                mdi-format-font
                                            </v-icon>
                                        </v-btn>
                                        <v-spacer></v-spacer>
                                        <v-btn icon :outlined="activeeditblock.textAlign==='left'"
                                               @click="activeeditblock.textAlign='left'">
                                            <v-icon>mdi-format-align-left</v-icon>
                                        </v-btn>
                                        <v-btn icon :outlined="activeeditblock.textAlign==='center'" small
                                               @click="activeeditblock.textAlign='center'">
                                            <v-icon>mdi-format-align-center</v-icon>
                                        </v-btn>
                                        <v-btn icon :outlined="activeeditblock.textAlign==='justify'" small
                                               @click="activeeditblock.textAlign='justify'">
                                            <v-icon>mdi-format-align-justify</v-icon>
                                        </v-btn>
                                        <v-btn icon small :outlined="activeeditblock.textAlign==='right'"
                                               @click="activeeditblock.textAlign='right'">
                                            <v-icon>mdi-format-align-right</v-icon>
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>

                                <!--TEXT EDITING-->
                                <v-card outlined v-if="['text','boxed text'].includes(activeeditblock.type)">
                                    <v-card-title class="text-capitalize">{{activeeditblock.type}}</v-card-title>
                                    <v-card-text class="pa-1 text-center" scrollable>
                                        <v-color-picker width="300" flat
                                                        v-if="['boxed text','header'].includes(activeeditblock.type)"
                                                        canvas-height="100" hide-inputs
                                                        v-model="activeeditblock.backgroundcolor"></v-color-picker>
                                        <v-textarea outlined rows="5" v-model="activeeditblock.text" class="pt-0"/>
                                        <v-slider thumb-label label="Padding" min="0" max="100"
                                                  v-model="activeeditblock.padding"></v-slider>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-btn outlined small @click="setFontSize()">
                                            <v-icon>{{`mdi-numeric-${sizeindex}`}}</v-icon>
                                        </v-btn>
                                        <v-btn v-if="activeeditblock.type==='boxed text'" depressed
                                               :dark="activeeditblock.color==='black'" :color="activeeditblock.color"
                                               small @click="setTextColor()">
                                            <v-icon>mdi-ghost</v-icon>
                                        </v-btn>
                                        <v-btn depressed dark small @click="setFontWeight()">
                                            <v-icon :style="`font-weight:${activeeditblock.fontweight}`">
                                                mdi-format-font
                                            </v-icon>
                                        </v-btn>
                                        <v-spacer></v-spacer>
                                        <v-btn icon :outlined="activeeditblock.textAlign==='left'"
                                               @click="activeeditblock.textAlign='left'">
                                            <v-icon>mdi-format-align-left</v-icon>
                                        </v-btn>
                                        <v-btn icon :outlined="activeeditblock.textAlign==='center'" small
                                               @click="activeeditblock.textAlign='center'">
                                            <v-icon>mdi-format-align-center</v-icon>
                                        </v-btn>
                                        <v-btn icon :outlined="activeeditblock.textAlign==='justify'" small
                                               @click="activeeditblock.textAlign='justify'">
                                            <v-icon>mdi-format-align-justify</v-icon>
                                        </v-btn>
                                        <v-btn icon small :outlined="activeeditblock.textAlign==='right'"
                                               @click="activeeditblock.textAlign='right'">
                                            <v-icon>mdi-format-align-right</v-icon>
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>

                                <!--IMAGE/MEDIA EDITING-->
                                <v-card outlined
                                        v-if="['image','image group', 'video', 'eventcard','html'].includes(activeeditblock.type)">
                                    <v-card-title class="text-capitalize">{{activeeditblock.type}}</v-card-title>
                                    <v-card-text class="pa-0 text-center" scrollable>
                                        <img :src="activeeditblock.src" height="80"/>
                                        <v-slider thumb-label label="Size" min="100" max="600"
                                                  v-model="activeeditblock.height"></v-slider>
                                    </v-card-text>
                                    <v-card-actions>
                                        <FileSelect @selectedfiles="setImages($event)" :selectcount="1"
                                                    :trigger="openfiles" @close="openfiles=false"/>
                                        <v-spacer></v-spacer>
                                        <v-btn icon :outlined="activeeditblock.textAlign==='left'"
                                               @click="()=>{activeeditblock.textAlign='left'}">
                                            <v-icon>mdi-format-align-left</v-icon>
                                        </v-btn>
                                        <v-btn icon :outlined="activeeditblock.textAlign==='center'"
                                               @click="()=>{activeeditblock.textAlign='center'}">
                                            <v-icon>mdi-format-align-center</v-icon>
                                        </v-btn>
                                        <v-btn icon small :outlined="activeeditblock.textAlign==='right'"
                                               @click="()=>{activeeditblock.textAlign='right'}">
                                            <v-icon>mdi-format-align-right</v-icon>
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>

                                <!--BUTTON-->
                                <v-card outlined v-if="activeeditblock.type==='button'">
                                    <v-card-title class="text-capitalize">{{activeeditblock.type}}</v-card-title>
                                    <v-card-text class="text-center" scrollable>
                                        <v-color-picker width="300" flat canvas-height="80" hide-inputs
                                                        v-model="activeeditblock.buttonbackgroundcolor"/>
                                        <v-text-field dense label="Button Text" outlined
                                                      v-model="activeeditblock.text"/>
                                        <v-text-field dense label="URL/To" outlined v-model="activeeditblock.url"/>
                                        <v-slider thumb-label label="Width" min="20" max="400"
                                                  v-model="activeeditblock.buttonwidth"></v-slider>
                                        <v-slider thumb-label label="Height" min="20" max="200"
                                                  v-model="activeeditblock.buttonheight"></v-slider>
                                        <v-slider thumb-label label="Padding" min="0" max="50"
                                                  v-model="activeeditblock.padding"></v-slider>
                                        <v-slider thumb-label label="Button Corners" min="0" max="20"
                                                  v-model="activeeditblock.buttonborderradius"></v-slider>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-btn icon :outlined="activeeditblock.textAlign==='left'"
                                               @click="activeeditblock.textAlign='left'">
                                            <v-icon>mdi-format-align-left</v-icon>
                                        </v-btn>
                                        <v-btn icon :outlined="activeeditblock.textAlign==='center'" small
                                               @click="activeeditblock.textAlign='center'">
                                            <v-icon>mdi-format-align-center</v-icon>
                                        </v-btn>
                                        <v-btn icon small :outlined="activeeditblock.textAlign==='right'"
                                               @click="activeeditblock.textAlign='right'">
                                            <v-icon>mdi-format-align-right</v-icon>
                                        </v-btn>
                                        <v-spacer></v-spacer>
                                        <v-btn depressed :dark="activeeditblock.buttoncolor==='black'"
                                               :color="activeeditblock.buttoncolor" small @click="setButtonColor()">
                                            <v-icon>mdi-ghost</v-icon>
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>

                                <!--SPACER EDITING-->
                                <v-card outlined v-if="['spacer'].includes(activeeditblock.type)">
                                    <v-card-title class="text-capitalize">{{activeeditblock.type}}</v-card-title>
                                    <v-card-text class="pa-1" scrollable>
                                        <v-slider thumb-label :label="`${activeeditblock.height}px`" min="50" max="100"
                                                  v-model="activeeditblock.height"></v-slider>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn icon small @click="confirmRemoveBlock()">
                                            <v-icon>mdi-server-remove</v-icon>
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>

                                <!--SOCIAL EDITING-->
                                <v-card outlined v-if="activeeditblock.type==='social'">
                                    <v-card-title class="text-capitalize">{{activeeditblock.type}}</v-card-title>
                                    <v-card-text class="pa-1">
                                        <v-list dense>
                                            <v-list-item v-for="s in socialnetworks" :key="s.type">
                                                <v-list-item-avatar size="30">
                                                    <v-img :src="`${iconurl}${s.type}.png`"/>
                                                </v-list-item-avatar>
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        {{s.type}}
                                                    </v-list-item-title>
                                                    <v-list-item-subtitle>
                                                        {{orgSocial[s.type] || 'Not Set'}}
                                                    </v-list-item-subtitle>
                                                </v-list-item-content>
                                                <v-list-item-action>
                                                    <v-checkbox
                                                            v-model="activeeditblock.socialselected"
                                                            color="primary"
                                                            :value="s.type"
                                                    ></v-checkbox>
                                                </v-list-item-action>
                                            </v-list-item>
                                        </v-list>
                                        <v-slider thumb-label :label="`${activeeditblock.iconheight}px`" min="20"
                                                  max="100" v-model="activeeditblock.iconheight"></v-slider>
                                        <v-slider thumb-label :label="`${activeeditblock.iconpadding}px`" min="0"
                                                  max="100" v-model="activeeditblock.iconpadding"></v-slider>
                                        <div class="text-center">
                                            <v-btn small color="indigo" text to="/organization/social">Edit Social
                                                Networks
                                            </v-btn>
                                        </div>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                    </v-card-actions>
                                </v-card>

                                <!--FOOTER EDITING-->
                                <v-card outlined v-if="[ 'footer'].includes(activeeditblock.type)">
                                    <v-card-title class="text-capitalize">{{activeeditblock.type}}</v-card-title>
                                    <v-card-text class="pa-1 text-center" scrollable>

                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                    </v-card-actions>
                                </v-card>

                            </v-card-text>
                            <!--CLOSE AND SAVE-->
                            <v-card-actions>
                                <v-btn color="black" dark @click="closeEdit()">Save</v-btn>
                                <v-spacer></v-spacer>
                                <v-btn color="black" dark @click="cancelEdit()">Cancel</v-btn>
                                <v-spacer></v-spacer>
                                <v-btn color="black" dark @click="confirmRemoveBlock()">Remove</v-btn>
                            </v-card-actions>
                        </v-card>

                        <!--TILES-->
                        <v-card v-else flat outlined class="navpanel">

                            <v-row no-gutters>
                                <v-col class="pa-1">
                                    <v-card class="" small depressed tile color="black" dark @click="setBodyActive()">
                                        <v-card-text class="cardol navtile">
                                            <v-icon>mdi-stretch-to-page-outline</v-icon>
                                            <div class="hidden-sm-and-down">Layout</div>
                                        </v-card-text>
                                    </v-card>
                                </v-col>
                                <v-col class="pa-1">
                                    <v-card class="" small depressed tile color="black" dark @click="myDrafts()">
                                        <v-card-text class="cardol navtile">
                                            <v-icon>mdi-file-outline</v-icon>
                                            <div class="hidden-sm-and-down">Drafts</div>
                                        </v-card-text>
                                    </v-card>
                                </v-col>
                                <v-col class="pa-1">
                                    <v-card class="" small depressed tile color="black" dark @click="createNew()">
                                        <v-card-text class="cardol navtile">
                                            <v-icon>mdi-email-plus-outline</v-icon>
                                            <div class="hidden-sm-and-down">New</div>
                                        </v-card-text>
                                    </v-card>
                                </v-col>
                                <!--<v-col>-->
                                <!--<v-btn small depressed tile color="black" dark @click="openSend()" :loading="sending" >-->
                                <!--<v-icon>mdi-email-send-outline</v-icon>-->
                                <!--<span class="hidden-sm-and-down">Send</span>-->
                                <!--</v-btn>-->
                                <!--</v-col>-->
                            </v-row>
                            <v-row no-gutters>
                                <v-col class="pa-1" cols="4" sm="4" md="4" lg="3" v-for="o in objects" :key="o.type">
                                    <drag :transfer-data="{ o }">
                                        <v-card outlined hover class="text-center navtile">
                                            <v-icon :large="$vuetify.breakpoint.mdAndUp">
                                                {{o.icon}}
                                            </v-icon>
                                            <div class="text-center text-capitalize font-weight-light subtitle-2"
                                                 style="overflow: hidden;">
                                                {{o.type}}
                                            </div>
                                        </v-card>
                                    </drag>
                                </v-col>
                            </v-row>


                        </v-card>
                    </div>
                    <div v-if="toolbar==='drafts'">
                        <v-card flat outlined>
                            <EmailList
                                    @loademail="loadActiveEmail($event)"
                                    @editemail="toolbar='edit',preview=false"
                                    :emails="mydrafts"
                                    :activeid="activeuuid"/>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn depressed tile color="black" dark @click="createNew()">New</v-btn>
                                <v-btn depressed tile color="black" dark @click="confirmdeletedialog=true"
                                       :disabled="!activeuuid">Delete
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </div>
                </v-col>

            </v-row>

            <v-dialog v-model="confirmremovedialog" width="300">
                <v-card v-if="activeeditblock">
                    <v-card-title>
                        remove {{activeeditblock.type}} ?
                    </v-card-title>
                    <v-card-text>
                        Remove
                        <div v-if="['text','boxed text', 'header', 'footer'].includes(activeeditblock.type)">
                            <v-icon>{{icons.openquote}}</v-icon>
                            {{activeeditblock.text}}
                        </div>
                        <div v-if="['image'].includes(activeeditblock.type)">
                            <img :src="activeeditblock.src" height="200"/>
                        </div>
                        <div v-if="['image','image group', 'video','share', 'eventcard','html'].includes(activeeditblock.type)">

                        </div>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn text @click="confirmremovedialog=false">Cancel</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn text @click="removeBlock()">Confirm</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="confirmdeletedialog" max-width="400">
                <v-card>
                    <v-card-title>
                        Delete
                    </v-card-title>
                    <v-card-text>
                        <div class="text-center subtitle-1">
                            <v-icon large color="warning">{{icons.warning}}</v-icon>
                            Confirm delete
                            <div class="headline">
                                <v-icon>{{icons.openquote}}</v-icon>
                                {{emailsubject || 'No Subject'}}
                                <v-icon>{{icons.closequote}}</v-icon>
                            </div>
                        </div>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn depressed @click="confirmdeletedialog=false">Cancel</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn depressed @click="deleteDraft()">Confirm</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="confirmsenddialog" max-width="400">
                <v-card>
                    <v-card-title>
                        Send
                    </v-card-title>
                    <v-card-text>
                        <v-text-field outlined v-model="emailsubject" label="Subject" hint="Subject is required"
                                      @change="saveDraft()"/>
                        <v-text-field outlined v-model="sendto" label="Send to Address"/>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn depressed @click="confirmsenddialog=false">Cancel</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn depressed color="primary" @click="send()" :loading="sending">Send</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

        </v-container>
    </v-main>
</template>

<style scoped>
    .cardol {
        border: solid thin #eeeeee
    }

    .navtile {
        height: 90px;
    }

    @media screen and (max-width: 960px) {
        /* For mobile phones: */
        .navtile {
            height: 50px;
        }
    }

    .content {
        position: inherit;
        border-radius: 5px;
        display: flex;
        justify-content: space-around;
        flex-flow: row wrap;
        align-items: stretch;
        border: dashed thin #8888ff;
    }

    /*used in content block to handle activeevents*/
    .flexbox {
        position: relative;
        flex-grow: 1;
        min-height: 50px;
    }

    .badgeicon {
        position: absolute;
        font-size: 2em;
        top: 0;
        left: 0;
        color: #00000055
    }

    .editbutton {
        position: absolute;
        top: 0;
        right: 0
    }

    .navpanel {
        min-height: 90vh
    }

    .dropcontainer {
        min-height: 90vh;
        background-color: white;
        display: inline-block;
    }

    .dragover {
        background-color: beige;
    }

    .bodyblocks {
        border-radius: 3px;
        min-height: 50px;
        width: 100%;
        margin-bottom: 3px;
    }

    .ghost {
        background-color: rgba(155, 155, 155, .5);
    }

    .topmenu {
        width: 100%;
        background-color: #222222;
        color: white;
    }

    .activeblock {
        border: solid 3px black
    }

    .hidden {
        visibility: hidden;
    }
</style>

<script>
  import {
    mapState,
    mapActions
  } from 'vuex'
  import draggable from 'vuedraggable'
  import FileSelect from "../FileSelect";
  import EmailPreview from "./EmailPreview";
  import EmailList from "./EmailList";
  import Header from "./blocks/Header";
  import BText from "./blocks/Text";
  import BoxedText from "./blocks/BoxedText";
  import BImage from "./blocks/BImage";
  import BButton from "./blocks/Button";
  import Spacer from "./blocks/Spacer";
  import BFooter from "./blocks/BFooter";
  import Social from "./blocks/Social";

  export default {
    components: {
      Social,
      BFooter,
      Spacer, BButton, BImage, BoxedText, BText, Header, EmailList, EmailPreview, FileSelect, draggable
    },
    name: "EmailComposer",
    data() {
      return {
        sending: false,
        socialicons: {
          twitter: 'mdi-twitter-box',
          youtube: 'mdi-youtube',
          facebook: 'mdi-facebook-box',
          instagram: 'mdi-instagram',
          linkedin: 'mdi-linkedin-box',
          pinterest: 'mdi-pinterest-box'
        },
        iconurl: 'https://18panelsadmin.s3-us-west-2.amazonaws.com/img/social/PNG/Circle+Color/',
        objects: [
          {
            type: 'header',
            icon: 'mdi-page-layout-header',
            height: 90,
            text: '',
            textAlign: 'center',
            backgroundcolor: {r: 255, g: 255, b: 255, a: 1}
          },
          {type: 'text', icon: 'mdi-card-text-outline', height: 90, text: '', textAlign: ''},
          {
            type: 'boxed text',
            icon: 'mdi-card-text',
            height: 90,
            text: '',
            color: 'black',
            textAlign: '',
            backgroundcolor: {r: 200, g: 200, b: 200, a: 1}
          },
          {type: 'image', icon: 'mdi-image', height: 90, width: 0, src: '', textAlign: ''},
          {type: 'image group', icon: 'mdi-view-dashboard-outline', height: 90, text: '', textAlign: ''},
          {
            type: 'button',
            icon: 'mdi-cursor-default-click',
            buttonbackgroundcolor: '#000000',
            buttoncolor: '#ffffff',
            height: 90,
            text: 'Button',
            textAlign: 'center',
            buttonborderradius: 2
          },
          //{type:'image background',icon:'mdi-image',height:90,text:'',textAlign:'',backgroundImage:''},
          {
            type: 'social',
            icon: 'mdi-share-variant',
            height: 90,
            text: '',
            textAlign: '',
            socialselected: [],
            iconpadding: 10
          },
          {type: 'video', icon: 'mdi-play-circle-outline', height: 90, text: '', textAlign: ''},
          {type: 'html', icon: 'mdi-code-tags', height: 90, text: ''},
          {type: 'event card', icon: 'mdi-calendar-check-outline', height: 90, text: '', textAlign: ''},
          {type: 'spacer', icon: 'mdi-arrow-expand-vertical', height: 50},
          {type: 'footer', icon: 'mdi-page-layout-footer', height: 90, text: '', textAlign: ''}
        ],
        blocks: [
          {
            type: 'header',
            icon: 'mdi-page-layout-header',
            height: 90,
            text: '',
            textAlign: 'center',
            backgroundcolor: {r: 255, g: 255, b: 255, a: 1}
          }
        ],
        emailbody: {
          borderradius: 3,
          bodywidth: 550,
          backgroundcolor: '#AAAAAA',
          bodyalignment: 'center',
          bodypadding: 5,
          bodypaddingy: 20
        },
        emailsubject: '',
        sendto: '',
        activeuuid: undefined,
        active: undefined,
        dragover: false,
        editindex: undefined,
        blockhover: undefined,
        activeeditblock: undefined,
        fontsizes: ['xx-small', 'x-small', 'small', 'medium', 'large', 'x-large', 'xx-large'],
        sizeindex: 0,
        rkey: '00',// a trigger key to trigger redraw of images with changes src
        openfiles: false,
        confirmremovedialog: false,
        toolboxtop: 1,
        toolbar: 'edit',
        preview: false,
        mydrafts: [],
        status: '',
        confirmdeletedialog: false,
        confirmsenddialog: false,
        latin_map: {
          "Á": "A",
          "Ă": "A",
          "Ắ": "A",
          "Ặ": "A",
          "Ằ": "A",
          "Ẳ": "A",
          "Ẵ": "A",
          "Ǎ": "A",
          "Â": "A",
          "Ấ": "A",
          "Ậ": "A",
          "Ầ": "A",
          "Ẩ": "A",
          "Ẫ": "A",
          "Ä": "A",
          "Ǟ": "A",
          "Ȧ": "A",
          "Ǡ": "A",
          "Ạ": "A",
          "Ȁ": "A",
          "À": "A",
          "Ả": "A",
          "Ȃ": "A",
          "Ā": "A",
          "Ą": "A",
          "Å": "A",
          "Ǻ": "A",
          "Ḁ": "A",
          "Ⱥ": "A",
          "Ã": "A",
          "Ꜳ": "AA",
          "Æ": "AE",
          "Ǽ": "AE",
          "Ǣ": "AE",
          "Ꜵ": "AO",
          "Ꜷ": "AU",
          "Ꜹ": "AV",
          "Ꜻ": "AV",
          "Ꜽ": "AY",
          "Ḃ": "B",
          "Ḅ": "B",
          "Ɓ": "B",
          "Ḇ": "B",
          "Ƀ": "B",
          "Ƃ": "B",
          "Ć": "C",
          "Č": "C",
          "Ç": "C",
          "Ḉ": "C",
          "Ĉ": "C",
          "Ċ": "C",
          "Ƈ": "C",
          "Ȼ": "C",
          "Ď": "D",
          "Ḑ": "D",
          "Ḓ": "D",
          "Ḋ": "D",
          "Ḍ": "D",
          "Ɗ": "D",
          "Ḏ": "D",
          "ǲ": "D",
          "ǅ": "D",
          "Đ": "D",
          "Ƌ": "D",
          "Ǳ": "DZ",
          "Ǆ": "DZ",
          "É": "E",
          "Ĕ": "E",
          "Ě": "E",
          "Ȩ": "E",
          "Ḝ": "E",
          "Ê": "E",
          "Ế": "E",
          "Ệ": "E",
          "Ề": "E",
          "Ể": "E",
          "Ễ": "E",
          "Ḙ": "E",
          "Ë": "E",
          "Ė": "E",
          "Ẹ": "E",
          "Ȅ": "E",
          "È": "E",
          "Ẻ": "E",
          "Ȇ": "E",
          "Ē": "E",
          "Ḗ": "E",
          "Ḕ": "E",
          "Ę": "E",
          "Ɇ": "E",
          "Ẽ": "E",
          "Ḛ": "E",
          "Ꝫ": "ET",
          "Ḟ": "F",
          "Ƒ": "F",
          "Ǵ": "G",
          "Ğ": "G",
          "Ǧ": "G",
          "Ģ": "G",
          "Ĝ": "G",
          "Ġ": "G",
          "Ɠ": "G",
          "Ḡ": "G",
          "Ǥ": "G",
          "Ḫ": "H",
          "Ȟ": "H",
          "Ḩ": "H",
          "Ĥ": "H",
          "Ⱨ": "H",
          "Ḧ": "H",
          "Ḣ": "H",
          "Ḥ": "H",
          "Ħ": "H",
          "Í": "I",
          "Ĭ": "I",
          "Ǐ": "I",
          "Î": "I",
          "Ï": "I",
          "Ḯ": "I",
          "İ": "I",
          "Ị": "I",
          "Ȉ": "I",
          "Ì": "I",
          "Ỉ": "I",
          "Ȋ": "I",
          "Ī": "I",
          "Į": "I",
          "Ɨ": "I",
          "Ĩ": "I",
          "Ḭ": "I",
          "Ꝺ": "D",
          "Ꝼ": "F",
          "Ᵹ": "G",
          "Ꞃ": "R",
          "Ꞅ": "S",
          "Ꞇ": "T",
          "Ꝭ": "IS",
          "Ĵ": "J",
          "Ɉ": "J",
          "Ḱ": "K",
          "Ǩ": "K",
          "Ķ": "K",
          "Ⱪ": "K",
          "Ꝃ": "K",
          "Ḳ": "K",
          "Ƙ": "K",
          "Ḵ": "K",
          "Ꝁ": "K",
          "Ꝅ": "K",
          "Ĺ": "L",
          "Ƚ": "L",
          "Ľ": "L",
          "Ļ": "L",
          "Ḽ": "L",
          "Ḷ": "L",
          "Ḹ": "L",
          "Ⱡ": "L",
          "Ꝉ": "L",
          "Ḻ": "L",
          "Ŀ": "L",
          "Ɫ": "L",
          "ǈ": "L",
          "Ł": "L",
          "Ǉ": "LJ",
          "Ḿ": "M",
          "Ṁ": "M",
          "Ṃ": "M",
          "Ɱ": "M",
          "Ń": "N",
          "Ň": "N",
          "Ņ": "N",
          "Ṋ": "N",
          "Ṅ": "N",
          "Ṇ": "N",
          "Ǹ": "N",
          "Ɲ": "N",
          "Ṉ": "N",
          "Ƞ": "N",
          "ǋ": "N",
          "Ñ": "N",
          "Ǌ": "NJ",
          "Ó": "O",
          "Ŏ": "O",
          "Ǒ": "O",
          "Ô": "O",
          "Ố": "O",
          "Ộ": "O",
          "Ồ": "O",
          "Ổ": "O",
          "Ỗ": "O",
          "Ö": "O",
          "Ȫ": "O",
          "Ȯ": "O",
          "Ȱ": "O",
          "Ọ": "O",
          "Ő": "O",
          "Ȍ": "O",
          "Ò": "O",
          "Ỏ": "O",
          "Ơ": "O",
          "Ớ": "O",
          "Ợ": "O",
          "Ờ": "O",
          "Ở": "O",
          "Ỡ": "O",
          "Ȏ": "O",
          "Ꝋ": "O",
          "Ꝍ": "O",
          "Ō": "O",
          "Ṓ": "O",
          "Ṑ": "O",
          "Ɵ": "O",
          "Ǫ": "O",
          "Ǭ": "O",
          "Ø": "O",
          "Ǿ": "O",
          "Õ": "O",
          "Ṍ": "O",
          "Ṏ": "O",
          "Ȭ": "O",
          "Ƣ": "OI",
          "Ꝏ": "OO",
          "Ɛ": "E",
          "Ɔ": "O",
          "Ȣ": "OU",
          "Ṕ": "P",
          "Ṗ": "P",
          "Ꝓ": "P",
          "Ƥ": "P",
          "Ꝕ": "P",
          "Ᵽ": "P",
          "Ꝑ": "P",
          "Ꝙ": "Q",
          "Ꝗ": "Q",
          "Ŕ": "R",
          "Ř": "R",
          "Ŗ": "R",
          "Ṙ": "R",
          "Ṛ": "R",
          "Ṝ": "R",
          "Ȑ": "R",
          "Ȓ": "R",
          "Ṟ": "R",
          "Ɍ": "R",
          "Ɽ": "R",
          "Ꜿ": "C",
          "Ǝ": "E",
          "Ś": "S",
          "Ṥ": "S",
          "Š": "S",
          "Ṧ": "S",
          "Ş": "S",
          "Ŝ": "S",
          "Ș": "S",
          "Ṡ": "S",
          "Ṣ": "S",
          "Ṩ": "S",
          "Ť": "T",
          "Ţ": "T",
          "Ṱ": "T",
          "Ț": "T",
          "Ⱦ": "T",
          "Ṫ": "T",
          "Ṭ": "T",
          "Ƭ": "T",
          "Ṯ": "T",
          "Ʈ": "T",
          "Ŧ": "T",
          "Ɐ": "A",
          "Ꞁ": "L",
          "Ɯ": "M",
          "Ʌ": "V",
          "Ꜩ": "TZ",
          "Ú": "U",
          "Ŭ": "U",
          "Ǔ": "U",
          "Û": "U",
          "Ṷ": "U",
          "Ü": "U",
          "Ǘ": "U",
          "Ǚ": "U",
          "Ǜ": "U",
          "Ǖ": "U",
          "Ṳ": "U",
          "Ụ": "U",
          "Ű": "U",
          "Ȕ": "U",
          "Ù": "U",
          "Ủ": "U",
          "Ư": "U",
          "Ứ": "U",
          "Ự": "U",
          "Ừ": "U",
          "Ử": "U",
          "Ữ": "U",
          "Ȗ": "U",
          "Ū": "U",
          "Ṻ": "U",
          "Ų": "U",
          "Ů": "U",
          "Ũ": "U",
          "Ṹ": "U",
          "Ṵ": "U",
          "Ꝟ": "V",
          "Ṿ": "V",
          "Ʋ": "V",
          "Ṽ": "V",
          "Ꝡ": "VY",
          "Ẃ": "W",
          "Ŵ": "W",
          "Ẅ": "W",
          "Ẇ": "W",
          "Ẉ": "W",
          "Ẁ": "W",
          "Ⱳ": "W",
          "Ẍ": "X",
          "Ẋ": "X",
          "Ý": "Y",
          "Ŷ": "Y",
          "Ÿ": "Y",
          "Ẏ": "Y",
          "Ỵ": "Y",
          "Ỳ": "Y",
          "Ƴ": "Y",
          "Ỷ": "Y",
          "Ỿ": "Y",
          "Ȳ": "Y",
          "Ɏ": "Y",
          "Ỹ": "Y",
          "Ź": "Z",
          "Ž": "Z",
          "Ẑ": "Z",
          "Ⱬ": "Z",
          "Ż": "Z",
          "Ẓ": "Z",
          "Ȥ": "Z",
          "Ẕ": "Z",
          "Ƶ": "Z",
          "Ĳ": "IJ",
          "Œ": "OE",
          "ᴀ": "A",
          "ᴁ": "AE",
          "ʙ": "B",
          "ᴃ": "B",
          "ᴄ": "C",
          "ᴅ": "D",
          "ᴇ": "E",
          "ꜰ": "F",
          "ɢ": "G",
          "ʛ": "G",
          "ʜ": "H",
          "ɪ": "I",
          "ʁ": "R",
          "ᴊ": "J",
          "ᴋ": "K",
          "ʟ": "L",
          "ᴌ": "L",
          "ᴍ": "M",
          "ɴ": "N",
          "ᴏ": "O",
          "ɶ": "OE",
          "ᴐ": "O",
          "ᴕ": "OU",
          "ᴘ": "P",
          "ʀ": "R",
          "ᴎ": "N",
          "ᴙ": "R",
          "ꜱ": "S",
          "ᴛ": "T",
          "ⱻ": "E",
          "ᴚ": "R",
          "ᴜ": "U",
          "ᴠ": "V",
          "ᴡ": "W",
          "ʏ": "Y",
          "ᴢ": "Z",
          "á": "a",
          "ă": "a",
          "ắ": "a",
          "ặ": "a",
          "ằ": "a",
          "ẳ": "a",
          "ẵ": "a",
          "ǎ": "a",
          "â": "a",
          "ấ": "a",
          "ậ": "a",
          "ầ": "a",
          "ẩ": "a",
          "ẫ": "a",
          "ä": "a",
          "ǟ": "a",
          "ȧ": "a",
          "ǡ": "a",
          "ạ": "a",
          "ȁ": "a",
          "à": "a",
          "ả": "a",
          "ȃ": "a",
          "ā": "a",
          "ą": "a",
          "ᶏ": "a",
          "ẚ": "a",
          "å": "a",
          "ǻ": "a",
          "ḁ": "a",
          "ⱥ": "a",
          "ã": "a",
          "ꜳ": "aa",
          "æ": "ae",
          "ǽ": "ae",
          "ǣ": "ae",
          "ꜵ": "ao",
          "ꜷ": "au",
          "ꜹ": "av",
          "ꜻ": "av",
          "ꜽ": "ay",
          "ḃ": "b",
          "ḅ": "b",
          "ɓ": "b",
          "ḇ": "b",
          "ᵬ": "b",
          "ᶀ": "b",
          "ƀ": "b",
          "ƃ": "b",
          "ɵ": "o",
          "ć": "c",
          "č": "c",
          "ç": "c",
          "ḉ": "c",
          "ĉ": "c",
          "ɕ": "c",
          "ċ": "c",
          "ƈ": "c",
          "ȼ": "c",
          "ď": "d",
          "ḑ": "d",
          "ḓ": "d",
          "ȡ": "d",
          "ḋ": "d",
          "ḍ": "d",
          "ɗ": "d",
          "ᶑ": "d",
          "ḏ": "d",
          "ᵭ": "d",
          "ᶁ": "d",
          "đ": "d",
          "ɖ": "d",
          "ƌ": "d",
          "ı": "i",
          "ȷ": "j",
          "ɟ": "j",
          "ʄ": "j",
          "ǳ": "dz",
          "ǆ": "dz",
          "é": "e",
          "ĕ": "e",
          "ě": "e",
          "ȩ": "e",
          "ḝ": "e",
          "ê": "e",
          "ế": "e",
          "ệ": "e",
          "ề": "e",
          "ể": "e",
          "ễ": "e",
          "ḙ": "e",
          "ë": "e",
          "ė": "e",
          "ẹ": "e",
          "ȅ": "e",
          "è": "e",
          "ẻ": "e",
          "ȇ": "e",
          "ē": "e",
          "ḗ": "e",
          "ḕ": "e",
          "ⱸ": "e",
          "ę": "e",
          "ᶒ": "e",
          "ɇ": "e",
          "ẽ": "e",
          "ḛ": "e",
          "ꝫ": "et",
          "ḟ": "f",
          "ƒ": "f",
          "ᵮ": "f",
          "ᶂ": "f",
          "ǵ": "g",
          "ğ": "g",
          "ǧ": "g",
          "ģ": "g",
          "ĝ": "g",
          "ġ": "g",
          "ɠ": "g",
          "ḡ": "g",
          "ᶃ": "g",
          "ǥ": "g",
          "ḫ": "h",
          "ȟ": "h",
          "ḩ": "h",
          "ĥ": "h",
          "ⱨ": "h",
          "ḧ": "h",
          "ḣ": "h",
          "ḥ": "h",
          "ɦ": "h",
          "ẖ": "h",
          "ħ": "h",
          "ƕ": "hv",
          "í": "i",
          "ĭ": "i",
          "ǐ": "i",
          "î": "i",
          "ï": "i",
          "ḯ": "i",
          "ị": "i",
          "ȉ": "i",
          "ì": "i",
          "ỉ": "i",
          "ȋ": "i",
          "ī": "i",
          "į": "i",
          "ᶖ": "i",
          "ɨ": "i",
          "ĩ": "i",
          "ḭ": "i",
          "ꝺ": "d",
          "ꝼ": "f",
          "ᵹ": "g",
          "ꞃ": "r",
          "ꞅ": "s",
          "ꞇ": "t",
          "ꝭ": "is",
          "ǰ": "j",
          "ĵ": "j",
          "ʝ": "j",
          "ɉ": "j",
          "ḱ": "k",
          "ǩ": "k",
          "ķ": "k",
          "ⱪ": "k",
          "ꝃ": "k",
          "ḳ": "k",
          "ƙ": "k",
          "ḵ": "k",
          "ᶄ": "k",
          "ꝁ": "k",
          "ꝅ": "k",
          "ĺ": "l",
          "ƚ": "l",
          "ɬ": "l",
          "ľ": "l",
          "ļ": "l",
          "ḽ": "l",
          "ȴ": "l",
          "ḷ": "l",
          "ḹ": "l",
          "ⱡ": "l",
          "ꝉ": "l",
          "ḻ": "l",
          "ŀ": "l",
          "ɫ": "l",
          "ᶅ": "l",
          "ɭ": "l",
          "ł": "l",
          "ǉ": "lj",
          "ſ": "s",
          "ẜ": "s",
          "ẛ": "s",
          "ẝ": "s",
          "ḿ": "m",
          "ṁ": "m",
          "ṃ": "m",
          "ɱ": "m",
          "ᵯ": "m",
          "ᶆ": "m",
          "ń": "n",
          "ň": "n",
          "ņ": "n",
          "ṋ": "n",
          "ȵ": "n",
          "ṅ": "n",
          "ṇ": "n",
          "ǹ": "n",
          "ɲ": "n",
          "ṉ": "n",
          "ƞ": "n",
          "ᵰ": "n",
          "ᶇ": "n",
          "ɳ": "n",
          "ñ": "n",
          "ǌ": "nj",
          "ó": "o",
          "ŏ": "o",
          "ǒ": "o",
          "ô": "o",
          "ố": "o",
          "ộ": "o",
          "ồ": "o",
          "ổ": "o",
          "ỗ": "o",
          "ö": "o",
          "ȫ": "o",
          "ȯ": "o",
          "ȱ": "o",
          "ọ": "o",
          "ő": "o",
          "ȍ": "o",
          "ò": "o",
          "ỏ": "o",
          "ơ": "o",
          "ớ": "o",
          "ợ": "o",
          "ờ": "o",
          "ở": "o",
          "ỡ": "o",
          "ȏ": "o",
          "ꝋ": "o",
          "ꝍ": "o",
          "ⱺ": "o",
          "ō": "o",
          "ṓ": "o",
          "ṑ": "o",
          "ǫ": "o",
          "ǭ": "o",
          "ø": "o",
          "ǿ": "o",
          "õ": "o",
          "ṍ": "o",
          "ṏ": "o",
          "ȭ": "o",
          "ƣ": "oi",
          "ꝏ": "oo",
          "ɛ": "e",
          "ᶓ": "e",
          "ɔ": "o",
          "ᶗ": "o",
          "ȣ": "ou",
          "ṕ": "p",
          "ṗ": "p",
          "ꝓ": "p",
          "ƥ": "p",
          "ᵱ": "p",
          "ᶈ": "p",
          "ꝕ": "p",
          "ᵽ": "p",
          "ꝑ": "p",
          "ꝙ": "q",
          "ʠ": "q",
          "ɋ": "q",
          "ꝗ": "q",
          "ŕ": "r",
          "ř": "r",
          "ŗ": "r",
          "ṙ": "r",
          "ṛ": "r",
          "ṝ": "r",
          "ȑ": "r",
          "ɾ": "r",
          "ᵳ": "r",
          "ȓ": "r",
          "ṟ": "r",
          "ɼ": "r",
          "ᵲ": "r",
          "ᶉ": "r",
          "ɍ": "r",
          "ɽ": "r",
          "ↄ": "c",
          "ꜿ": "c",
          "ɘ": "e",
          "ɿ": "r",
          "ś": "s",
          "ṥ": "s",
          "š": "s",
          "ṧ": "s",
          "ş": "s",
          "ŝ": "s",
          "ș": "s",
          "ṡ": "s",
          "ṣ": "s",
          "ṩ": "s",
          "ʂ": "s",
          "ᵴ": "s",
          "ᶊ": "s",
          "ȿ": "s",
          "ɡ": "g",
          "ᴑ": "o",
          "ᴓ": "o",
          "ᴝ": "u",
          "ť": "t",
          "ţ": "t",
          "ṱ": "t",
          "ț": "t",
          "ȶ": "t",
          "ẗ": "t",
          "ⱦ": "t",
          "ṫ": "t",
          "ṭ": "t",
          "ƭ": "t",
          "ṯ": "t",
          "ᵵ": "t",
          "ƫ": "t",
          "ʈ": "t",
          "ŧ": "t",
          "ᵺ": "th",
          "ɐ": "a",
          "ᴂ": "ae",
          "ǝ": "e",
          "ᵷ": "g",
          "ɥ": "h",
          "ʮ": "h",
          "ʯ": "h",
          "ᴉ": "i",
          "ʞ": "k",
          "ꞁ": "l",
          "ɯ": "m",
          "ɰ": "m",
          "ᴔ": "oe",
          "ɹ": "r",
          "ɻ": "r",
          "ɺ": "r",
          "ⱹ": "r",
          "ʇ": "t",
          "ʌ": "v",
          "ʍ": "w",
          "ʎ": "y",
          "ꜩ": "tz",
          "ú": "u",
          "ŭ": "u",
          "ǔ": "u",
          "û": "u",
          "ṷ": "u",
          "ü": "u",
          "ǘ": "u",
          "ǚ": "u",
          "ǜ": "u",
          "ǖ": "u",
          "ṳ": "u",
          "ụ": "u",
          "ű": "u",
          "ȕ": "u",
          "ù": "u",
          "ủ": "u",
          "ư": "u",
          "ứ": "u",
          "ự": "u",
          "ừ": "u",
          "ử": "u",
          "ữ": "u",
          "ȗ": "u",
          "ū": "u",
          "ṻ": "u",
          "ų": "u",
          "ᶙ": "u",
          "ů": "u",
          "ũ": "u",
          "ṹ": "u",
          "ṵ": "u",
          "ᵫ": "ue",
          "ꝸ": "um",
          "ⱴ": "v",
          "ꝟ": "v",
          "ṿ": "v",
          "ʋ": "v",
          "ᶌ": "v",
          "ⱱ": "v",
          "ṽ": "v",
          "ꝡ": "vy",
          "ẃ": "w",
          "ŵ": "w",
          "ẅ": "w",
          "ẇ": "w",
          "ẉ": "w",
          "ẁ": "w",
          "ⱳ": "w",
          "ẘ": "w",
          "ẍ": "x",
          "ẋ": "x",
          "ᶍ": "x",
          "ý": "y",
          "ŷ": "y",
          "ÿ": "y",
          "ẏ": "y",
          "ỵ": "y",
          "ỳ": "y",
          "ƴ": "y",
          "ỷ": "y",
          "ỿ": "y",
          "ȳ": "y",
          "ẙ": "y",
          "ɏ": "y",
          "ỹ": "y",
          "ź": "z",
          "ž": "z",
          "ẑ": "z",
          "ʑ": "z",
          "ⱬ": "z",
          "ż": "z",
          "ẓ": "z",
          "ȥ": "z",
          "ẕ": "z",
          "ᵶ": "z",
          "ᶎ": "z",
          "ʐ": "z",
          "ƶ": "z",
          "ɀ": "z",
          "ﬀ": "ff",
          "ﬃ": "ffi",
          "ﬄ": "ffl",
          "ﬁ": "fi",
          "ﬂ": "fl",
          "ĳ": "ij",
          "œ": "oe",
          "ﬆ": "st",
          "ₐ": "a",
          "ₑ": "e",
          "ᵢ": "i",
          "ⱼ": "j",
          "ₒ": "o",
          "ᵣ": "r",
          "ᵤ": "u",
          "ᵥ": "v",
          "ₓ": "x"
        }
      }
    },
    computed: {
      ...mapState(['icons', 'org', 'socialnetworks']),
      orgSocial() {
        return this.org.social
      }
    },
    mounted() {
      this.loadFromStorage()
      //keeps the side menu in place
      document.addEventListener('scroll', this.setTop)
    },
    watch: {
      editindex() {
        this.sizeindex = 3
      }
    },
    methods: {
      ...mapActions(['post', 'get', 'delete']),
      loadFromStorage() {
        let d = window.localStorage.getItem('draft')
        if (d) {
          let dd = JSON.parse(d);
          this.blocks = dd.blocks;
          this.body = dd.body;
          this.activeuuid = dd.activeuuid
          this.emailsubject = dd.emailsubject
          this.status = 'draft'
        }
      },
      async saveToLocalStorage() {
        let draft = {
          blocks: this.blocks,
          body: this.body,
          activeuuid: this.activeuuid,
          emailsubject: this.emailsubject,
          status: this.status
        }
        window.localStorage.setItem('draft', JSON.stringify(draft))
      },
      setTop() {
        let sy = window.scrollY
        this.toolboxtop = sy;//every third (or 5th) set it..
      },
      log(e) {

      },
      handleDrop(data) {
        this.dragover = false
        if (data && data.o) {
          if (data.o.type === 'header') {
            if (this.blocks.filter(f => {
              return f.type === 'header'
            }).length > 0) return //not allow 2 hea
            this.blocks.unshift(data.o)
          } else {
            this.blocks.push(data.o)
            this.editindex = (this.blocks.length - 1)
            this.activeeditblock = this.blocks[this.editindex]
          }
        }
        this.saveDraft()
      },
      editBlock(index) {
        if (this.editindex === index) {
          this.editindex = undefined
          return
        }
        this.editindex = index
        this.activeeditblock = this.blocks[index]
        this.toolbar = 'edit'
        this.preview = false
      },
      closeEdit() {
        this.saveDraft()
        this.activeeditblock = undefined
        this.editindex = undefined
      },
      cancelEdit() {
        this.activeeditblock = undefined
        this.editindex = undefined
      },
      confirmRemoveBlock() {
        this.confirmremovedialog = true;
      },
      removeBlock() {
        this.confirmremovedialog = false;
        this.activeeditblock = undefined
        this.blocks.splice(this.editindex, 1)
        this.editindex = undefined
        this.saveDraft()
      },
      setFontSize() {
        this.sizeindex < 6 ? this.sizeindex++ : this.sizeindex = 0
        this.$set(this.blocks[this.editindex], 'fontsize', this.fontsizes[this.sizeindex])
        this.saveDraft()
      },
      setImages(e) {
        this.openfiles = false
        if (Array.isArray(e)) {
          return
        }
        let b = this.blocks[this.editindex]// convenience
        this.$set(b, 'src', e)
        this.saveDraft()
      },
      setItemVal(key, val) {
        let b = this.blocks[this.editindex]// convenience
        this.$set(b, key, val)
      },
      setTextColor() {
        let b = this.blocks[this.editindex]// convenience
        if (b.color && b.color === 'black') {
          this.$set(b, 'color', 'white')
        } else {
          this.$set(b, 'color', 'black')
        }
        this.saveDraft()
      },
      setButtonColor() {
        let b = this.blocks[this.editindex]// convenience
        if (b.buttoncolor && b.buttoncolor === 'black') {
          this.$set(b, 'buttoncolor', 'white')
        } else {
          this.$set(b, 'buttoncolor', 'black')
        }
        this.saveDraft()
      },
      setFontWeight() {
        let w = ['lighter', 'normal', 'bold']
        let b = this.blocks[this.editindex]// convenience
        if (!b.fontweight) {
          this.$set(b, 'fontweight', w[1])
        } else {
          let f = w.indexOf(b.fontweight)
          if (f < 2) f++
          else f = 0;
          this.$set(b, 'fontweight', w[f])
        }
        this.saveDraft()
      },
      async saveDraft() {
        await this.saveToLocalStorage()
        let email = {
          blocks: this.blocks,
          body: this.emailbody,
          uuid: this.activeuuid,
          subject: this.emailsubject,
          status: this.status
        }
        let res = await this.post({path: 'api/email/savedraft', body: {data: email}})
        this.activeuuid = res.uuid
        console.log(res)
      },
      async deleteDraft() {
        let index = this.mydrafts.findIndex(f => {
          f.uuid = this.activeuuid
        })
        await this.delete({path: 'api/email/draft', body: {uuid: this.activeuuid}})
        this.myDrafts()
        this.createNew()
        this.confirmdeletedialog = false

      },
      async myDrafts() {
        this.toolbar = 'drafts'
        this.preview = true
        this.mydrafts = await this.get({path: 'api/email/emaildrafts'})
        console.log(this.mydrafts)
      },
      createNew() {
        let ln = this.objects.length
        let draft = {
          blocks: [
            this.objects[0],
            this.objects[1],
            this.objects[ln - 1]
          ],//ie fill it with the blank text-box object
          body: {
            borderradius: 3,
            bodywidth: 550,
            backgroundcolor: '#AAAAAA',
            bodyalignment: 'center',
            bodypadding: 5,
            bodypaddingy: 20
          },
          activeuuid: undefined,
          status: 'draft'
        }
        window.localStorage.setItem('draft', JSON.stringify(draft))
        this.preview = false
        this.toolbar = 'edit'
        this.loadFromStorage()
      },
      loadActiveEmail(d) {
        console.log(d)
        let dd = d.data;
        this.blocks = dd.blocks;
        this.emailbody = dd.body
        this.activeuuid = d.uuid;
        this.status = d.status
        this.emailsubject = d.subject
        //this.toolbar = 'edit'
      },
      confirmSend() {
        this.confirmsenddialog = true
      },
      async send() {
        if (!this.emailsubject) return;
        this.sending = true;
        let p = await this.post({path: 'api/email/send', body: {uuid: this.activeuuid, sendto: this.sendto}})
        console.log(p)
        this.sending = false
        this.confirmsenddialog = false
        this.createNew()
        this.myDrafts()
      },
      setBodyActive() {
        this.activeeditblock = {type: 'body'}
      },
      unicodeReplace() {
        let em = this
        console.log('Changed')
        this.activeeditblock.text.replace(/[^\x00-\x80]/g,
          function (a) {
            console.log(a, em.latin_map[a])
            return 'HH';
          }
        );
        this.$forceUpdate()
      }
    },
  }
</script>

